import { configApi } from '../http-client.js'

export const getLandingPageInfo = productId => {
	return configApi.get(`/api/landing?productId=${productId}`)
}
